// @ts-check
import { options } from "@/global/slick-options";
import { getAll } from "PARENT/utilities/querySelector.js";

jQuery(function ($) {
    const sliders = getAll("[data-card-slider]");

    sliders.forEach((slider) => {
        const size = slider.getAttribute("data-card-slider-size");
        const additionalOptions = JSON.parse(
            slider.getAttribute("data-slider-options") ?? "{}",
        );

        let customOptions = {};
        let defaultOptions = { ...options };

        if (size === "tiny") {
            customOptions = {
                ...defaultOptions,
                slidesToShow: 6,
                responsive: [
                    {
                        breakpoint: 1300,
                        settings: {
                            slidesToShow: 5,
                        },
                    },
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 4,
                        },
                    },
                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 500,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                ],
            };
        } else if (size === "small") {
            customOptions = {
                ...defaultOptions,
                slidesToShow: 4,
                responsive: [
                    {
                        breakpoint: 1250,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 850,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            };
        } else if (size == "medium") {
            customOptions = {
                ...defaultOptions,
                slidesToShow: 3,
                responsive: [
                    {
                        breakpoint: 1100,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            };
        } else if (size == "large") {
            customOptions = {
                ...defaultOptions,
                slidesToShow: 1.33,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            };
        } else if (size == "huge") {
            customOptions = {
                ...defaultOptions,
                slidesToShow: 1,
            };
        } else {
            customOptions = {
                ...defaultOptions,
            };
        }

        $(slider).slick({
            ...customOptions,
            ...additionalOptions,
        });
    });
});
